export const testimonials = [
  {
    name: 'Dr. Andrea Ruiz',
    role: 'General Dentist',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/313ad198-4cf2-4724-82ef-2d8e244cc657.jpg',
    quote:
      'I was looking for a more organized way to review pediatric orthodontic cases. Having the assessment topics and clinical considerations arranged in one reference makes studying specific situations easier.',
  },
  {
    name: 'Dr. Carlos Medina',
    role: 'Pediatric Dentist',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/8d6cb10a-69a2-4433-81c2-2f2ee402c37e.jpg',
    quote:
      'The appliance comparison tables are the type of reference I appreciate when reviewing treatment alternatives. They help me organize the questions I need to consider before reaching a clinical decision.',
  },
  {
    name: 'Dr. Sofía Herrera',
    role: 'General Dentist',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/b93736e4-4ab2-4dc6-bbb3-9fdfcf32500d.jpg',
    quote:
      'I like that the material covers more than appliances. The sections on assessment, developmental considerations, and follow-up help connect different parts of the clinical reasoning process.',
  },
  {
    name: 'Dr. Javier Ortega',
    role: 'Family Dentist',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/117773f7-898f-43ec-ac5c-e5999a658e87.jpg',
    quote:
      'The worksheets offer a practical way to organize case information and document the points that need further evaluation.',
  },
  {
    name: 'Dr. Lucía Paredes',
    role: 'Orthodontics Resident',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/7217c25f-3db6-4d25-ad53-0ad7b6e72a11.jpg',
    quote:
      'I wanted a focused educational resource that I could revisit without having to search through several different references. This is the kind of format I find useful for professional study.',
  },
  {
    name: 'Dr. Mateo Castillo',
    role: 'General Dentist',
    photo: 'https://cdn.magicpatterns.com/patterns/generated-images/7df1c9da-36b5-41d8-93f0-2c745ec5d1d3.jpg',
    quote:
      'The red flags checklist changed how I prepare for conversations with parents. I can now explain why a finding needs closer attention and when a specialist referral makes sense.',
  },
];
